import { FC } from "react"
import { useFindContactFormsQuery } from "../../../../redux/queries"
import { Brand } from "../../../../types"
import { useBrandSearchParam } from "../../../hooks"
import ConfigListShell from "../config-list-shell"
import ContactFormTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigContactForm: FC<Props> = ({ brands }) => {
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()

  const { data: contactForms, isFetching } = useFindContactFormsQuery(
    selectedBrandId,
    { skip: !selectedBrandId }
  )

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
    >
      {selectedBrandId ? (
        <ContactFormTable data={contactForms ?? []} isFetching={isFetching} />
      ) : null}
    </ConfigListShell>
  )
}

export default ConfigContactForm
